import {jsonSchema} from "@cm/graph-v3"
import {z} from "zod/v4-mini"

export function isValidExternalId(id: string) {
    if (id.length === 0) return false
    else return /^[a-zA-Z0-9_\/-]+$/.test(id)
}

export const externalId = z.string().check(z.refine(isValidExternalId))
export type ExternalId = z.infer<typeof externalId>

export const transformValue = z.array(z.number()).check(z.length(16))
export type TransformValue = z.infer<typeof transformValue>
export const isTransformValue = (value: unknown): value is TransformValue => transformValue.safeParse(value).success

export const anyJsonValue = jsonSchema
export type AnyJsonValue = z.infer<typeof anyJsonValue>
export const isAnyJsonValue = (value: unknown): value is AnyJsonValue => anyJsonValue.safeParse(value).success

export const lodType = z.enum(["web", "ar", "pathTraced"])
export type LodTypeValue = z.infer<typeof lodType>
export const getLodTypeDescription = (lodType: LodTypeValue) => {
    switch (lodType) {
        case "web":
            return "Web"
        case "ar":
            return "AR"
        case "pathTraced":
            return "Path-traced"
    }
}

export enum ImageColorSpace {
    Gamma_2_0 = "Gamma_2_0",
    Gamma_2_2 = "Gamma_2_2",
    Linear = "Linear",
    Srgb = "Srgb",
    Unknown = "Unknown",
}
export const imageColorSpace = z.enum(ImageColorSpace)
